import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { AuthBackgroundSemantic_getInstance55rb2qz6vrk4 as AuthBackgroundSemantic_getInstance } from '../../theming/auth.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { AuthDialogSemantic_getInstancetw8ua0jubs3m as AuthDialogSemantic_getInstance } from '../../theming/appTheme.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { get_rawSession1kjo1nj4tz6n0 as get_rawSession } from '../../../sdk/UserSession.mjs';
import { Companion_getInstance33aui7uk8ap15 as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_currentContractor2yiwyln4wfsro as get_currentContractor } from '../../../selectedContractor.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from '../common/LandingScreen.mjs';
import { ContractorStatus_Registering_getInstance9wzvdghru4x2 as ContractorStatus_Registering_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function authCol(_this__u8e3s4, setup) {
  var tmp = _this__u8e3s4.kbb(get_expanding(_this__u8e3s4), _this__u8e3s4.jbb(AuthBackgroundSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Space())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view.hbb(p_0, view_0);
  var tmp_0 = view.kbb(get_centered(view), view.jbb(AuthDialogSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  view_1.gba(get_AppDimensions().yg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.zbm(true);
  setup(view_2);
  view_1.hbb(p_2, view_2);
  view.hbb(p_1, view_1);
  view.lbb(tmp_0, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Space())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  view.hbb(p_3, view_3);
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function authFrame(_this__u8e3s4, setup) {
  var tmp = _this__u8e3s4.kbb(get_expanding(_this__u8e3s4), _this__u8e3s4.jbb(AuthBackgroundSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  setup(view);
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function handleAuthRendering(_this__u8e3s4, center, requireRegistering, render) {
  center = center === VOID ? false : center;
  requireRegistering = requireRegistering === VOID ? true : requireRegistering;
  var tmp = get_unpadded(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (SwapView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  if (requireRegistering) {
    launch(view, VOID, VOID, handleAuthRendering$slambda_0(view));
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
  var this_0 = view;
  var queue = ArrayList().w();
  var alreadySwapping = {_v: false};
  reactiveScope(this_0, ($this$reactiveScope) => {
    var c = !($this$reactiveScope.daj(get_rawSession()) == null);
    queue.v(c);
    var tmp;
    if (alreadySwapping._v) {
      return Unit_instance;
    }
    alreadySwapping._v = true;
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!queue.i1()) {
        break $l$loop;
      }
      var next = queue.z3(0);
      try {
        var tmp_0 = Companion_getInstance().xax_1;
        this_0.tci(tmp_0, handleAuthRendering$lambda$lambda(next, center, render));
      } catch ($p) {
        if ($p instanceof Exception()) {
          var e = $p;
          report(Exception().vd('Failed to render ' + toString(next), e), 'SwapView.swapping');
        } else {
          throw $p;
        }
      }
    }
    alreadySwapping._v = false;
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_rawSession();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_currentContractor();
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var con = tmp_1;
  if (!(session == null) && !con.r5j_1.equals(ContractorStatus_Registering_getInstance())) {
    get_mainPageNavigator($this.pj1_1).gbw(new (LandingScreen())());
  }
  return Unit_instance;
}
var handleAuthRendering$slambdaClass;
function handleAuthRendering$slambda() {
  if (handleAuthRendering$slambdaClass === VOID) {
    class $ {
      constructor($$this$swapView) {
        this.pj1_1 = $$this$swapView;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    handleAuthRendering$slambdaClass = $;
  }
  return handleAuthRendering$slambdaClass;
}
function handleAuthRendering$slambda_0($$this$swapView) {
  var i = new (handleAuthRendering$slambda())($$this$swapView);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function handleAuthRendering$lambda$lambda($next, $center, $render) {
  return ($this$swap) => {
    var loggedIn = $next;
    var tmp;
    if (!loggedIn) {
      var tmp_0;
      if ($center) {
        var tmp_1 = get_scrolling($this$swap);
        tmp_0 = $this$swap.lbb(tmp_1, authFrame($this$swap, ($this$authFrame) => {
          $render($this$authFrame, loggedIn);
          return Unit_instance;
        }));
      } else {
        var tmp_2 = get_scrolling($this$swap);
        tmp_0 = $this$swap.lbb(tmp_2, authCol($this$swap, ($this$authCol) => {
          $render($this$authCol, loggedIn);
          return Unit_instance;
        }));
      }
      tmp = tmp_0;
    } else {
      var tmp_3 = get_scrolling($this$swap);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (Frame())($this$swap.pc());
      var tmp0_elvis_lhs = $this$swap.ebb_1;
      var p = tmp0_elvis_lhs == null ? $this$swap : tmp0_elvis_lhs;
      $this$swap.gbb(p, view);
      $render(view, loggedIn);
      $this$swap.hbb(p, view);
      tmp = $this$swap.lbb(tmp_3, view);
    }
    return tmp;
  };
}
//region block: exports
export {
  authCol as authCol17erwkvgugxzv,
  authFrame as authFrameoft44vbj3f9u,
  handleAuthRendering as handleAuthRendering280086oqucnha,
};
//endregion

//# sourceMappingURL=handleAuthRendering.mjs.map
